export enum STATUSAPI {
  SUCCESS = 200,
  POST_SUCCESS = 201,
  PATCH_SUCCESS = 204,
  CONFLICT = 409,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  NOT_FOUND = 404
}
